import { atom } from 'jotai';
import {
  InstrumentStoreComplexBookData,
  InstrumentStoreItem,
  ListedInstrument,
  MakePropertyOptional,
  WithoutId,
} from '../../types';
import { atomWithBroadcast } from '../core/atomWithBroadcast';

export type WatchListInstrumentFull = {
  /** Not displayed */
  id: string;
  /** Not displayed */
  instrumentStoreItem?: InstrumentStoreItem;
  instrument: ListedInstrument;
  lastPrice?: number;
  /** Not displayed */
  closePrice?: number;
  change?: number;
  changePercent?: number;
  bidPrice?: InstrumentStoreComplexBookData;
  askPrice?: InstrumentStoreComplexBookData;
  low?: number;
  high?: number;
  averagePrice?: number;
  volumeQuantity?: number;
  volumeValue?: number;
  annualLow?: number;
  annualHigh?: number;
  name?: string;
  market?: string;
  currency?: string;
  strikePrice?: number;
  strikeBarrier?: number;
};

export type WatchListInstrument = Omit<
  WithoutId<WatchListInstrumentFull>,
  'instrumentStoreItem' | 'price' | 'closePrice'
>;

export type WatchListColumn = {
  field: keyof WatchListInstrument;
  selected?: boolean | null;
};

export type WatchListGroupId = {
  id: number;
  name: string;
};

export type WatchListGroup = WatchListGroupId & {
  columns: Array<WatchListColumn>;
  items: Array<WatchListInstrumentFull>;
};

export type EditedWatchlistGroup = MakePropertyOptional<WatchListGroup, 'id'>;

export type WatchListGroupState = {
  watchListGroups: Array<WatchListGroup>;
  isLoading: boolean;
  error?: boolean;
};

export type WatchListDefault = {
  id: number;
  name: string;
};

export type WatchlistDefaultState = {
  isLoading: boolean;
  error: boolean;
  defaults: Array<WatchListDefault>;
};

export const watchListGroupsAtom = atomWithBroadcast<WatchListGroupState>('watchList/groups', {
  isLoading: true,
  error: false,
  watchListGroups: [],
});

export const watchListGroupIdsSelector = atom<Array<WatchListGroupId>>(get => {
  const watchListItems = get(watchListGroupsAtom);
  return watchListItems.watchListGroups.reduce((acc, currentValue) => {
    if (!acc.some(watchListGroup => watchListGroup.id === currentValue.id)) {
      acc.push({
        id: currentValue.id,
        name: currentValue.name,
      });
    }
    return acc;
  }, [] as Array<WatchListGroupId>);
});

export const watchListDefaultsAtom = atom<WatchlistDefaultState>({
  isLoading: false,
  error: false,
  defaults: [],
});
